import {Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {Aspar} from './Aspar';
import {DomSanitizer} from '@angular/platform-browser';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Globals} from '../globals';
import {Zinuzh} from '../zinuzh/Zinuzh';

@Component({
  selector: 'app-aspar',
  templateUrl: './aspar.component.html',
  styleUrls: ['./aspar.component.scss']
})
export class AsparComponent implements OnInit {
  videoFile = '../../assets/video/560154995.mp4';
  aspar: Aspar;
  value = true;
  headerPic;

  config: any = {
    //  effect:'fade',
    autoplay: false, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 3, // Slides Visible in Single View Default is 1
    spaceBetween: 20,
    paginationClickable: true, // Making pagination dots clicable
    nextButton: '.swiper-button-next', // Class for next button
    prevButton: '.swiper-button-prev', // Class for prev button
    pagination: '.swiper-pagination', // Pagination Class defined

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1050: {
        slidesPerView: 2,
      },
      800: {
        slidesPerView: 1,
      }
    },
    speed: 1000,
    loop: false,

    zoomToggle: false,
    setWrapperSize: true
  };
  somethingChanged: any;
  dataToSend: any;
  isShown: boolean = false;


  dateChanged(val: any) {
    var num;
    ;
    this.somethingChanged = val.value.toString().split(' ');
    if (this.somethingChanged[1] == 'Jan') {
      num = '01';
    } else if (this.somethingChanged[1] == 'Feb') {
      num = '02';
    } else if (this.somethingChanged[1] == 'Mar') {
      num = '03';
    } else if (this.somethingChanged[1] == 'Apr') {
      num = '04';
    } else if (this.somethingChanged[1] == 'May') {
      num = '05';
    } else if (this.somethingChanged[1] == 'Jun') {
      num = '06';
    } else if (this.somethingChanged[1] == 'Jul') {
      num = '07';
    } else if (this.somethingChanged[1] == 'Aug') {
      num = '08';
    } else if (this.somethingChanged[1] == 'Sep') {
      num = '09';
    } else if (this.somethingChanged[1] == 'Oct') {
      num = '10';
    } else if (this.somethingChanged[1] == 'Nov') {
      num = '11';
    } else if (this.somethingChanged[1] == 'Dec') {
      num = '12';
    }
    this.dataToSend = this.somethingChanged[3] + '-' + num + '-' + this.somethingChanged[2];
    // console.log(this.dataToSend)
    this.http.get<Aspar>(this.globals.urlMain + 'aspar', {
      params: {
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.aspar = data;

    });

  }

  constructor(private http: HttpClient, private route: ActivatedRoute, public sanitizer: DomSanitizer, private _location: Location, public globals: Globals) {
  }

  ngOnInit() {
    $(window).scrollTop(0);
// if(this.aspar.data.player_images){
// this.value= true;
// }

    this.http.get<Aspar>(this.globals.urlMain + 'aspar').subscribe(data => {
      this.aspar = data;
      this.headerPic = data.data.header_img;
    });
    localStorage.setItem('headerImage', this.headerPic);


  }

  changeAudios(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    var id = $(target).attr('data-id');
    var newsrc = $(target).closest('.asparSmall').find('audio').attr('src');
    console.log('***************************************newsrc***********************************');
    console.log(target);
    console.log(newsrc);
    console.log(id);
    var audio = document.createElement('audio');
    audio.src = newsrc;
    // alert(audio.src )
    audio.style.height = '30px';
    audio.style.width = '100%';
    audio.controls = true;
    var oldaudio = document.createElement('audio');
    oldaudio.src = $('.largePic.aspar').find('audio').attr('src');
    oldaudio.style.height = '30px';
    oldaudio.style.width = '100%';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('#' + id).html('').append(oldaudio);
    $('#' + id).append($(target));

    $('.largePic.aspar ').find('audio').remove();
    $('.largePic.aspar').prepend(audio);


  }

  changeAudio(index) {
    const item = this.aspar.data.aspar.aspar_reportajner[index];

    // @ts-ignore
    this.aspar.data.aspar.aspar_reportajner[index] = this.aspar.data.aspar.aspar_glxavor;

    // @ts-ignore
    this.aspar.data.aspar.aspar_glxavor = item;
  }

  changeVideo(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    // var value = idAttr.nodeValue;

    var id = $(target).attr('data-id');
    var newImgsrc = $('.bigVideoZinujPage').find('img').attr('src');
    var newVideo = $('.bigVideoZinujPage').find('iframe').attr('src');
    var newsrc = $(target).closest('.zinujPageSmalls').find('img').attr('data-id');
    console.log(id);
    var iframe = document.createElement('iframe');
    iframe.src = newsrc;
    iframe.height = '100%';
    iframe.width = '100%';
    $('.bigVideoZinujPage').find('img').attr('src', $(target).closest('.zinujPageSmalls').find('img').attr('src'));
    var oldIframe = document.createElement('img');
    oldIframe.src = newImgsrc;
    oldIframe.setAttribute('data-id', newVideo);
    oldIframe.style.height = '100%';
    oldIframe.style.width = '100%';
    // $(target).closest('.smallZinuj').remove();
    $('#' + id).find('img').remove();
    $('#' + id).prepend(oldIframe);
    $('#' + id).append($(target));

    $('.bigVideoZinujPage ').find('iframe').remove();
    $('.bigVideoZinujPage').prepend(iframe);

  };

  openModalaudio(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var audiosrc = $(target).closest('.itemContent').find('audio').attr('data-id');
    var newIframe = document.createElement('img');
    newIframe.src = iframe;
    newIframe.style.width = '100%';
    newIframe.style.objectFit = 'cover';
    // newIframe.allowFullscreen= true;
    // var audio = document.createElement('iframe');
    // audio.src= audiosrc;

    var oldaudio = document.createElement('audio');
    oldaudio.src = audiosrc;
    oldaudio.style.height = '30px';
    oldaudio.style.width = '92%';
    oldaudio.style.position = 'absolute';
    oldaudio.style.bottom = '30px';
    oldaudio.style.zIndex = '9';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('.modalDescription').html('').append(oldaudio);
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

    // height: 30px;
    // width: 92%;
    // position: absolute;
    // margin-top: 58%;

  };

  openModal(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '93%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);
  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }


  back() {
    this._location.back();

  }


  toggleShow() {

    this.isShown = !this.isShown;

  }

  sendXoragirId(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.data - id;
    var id = $(target).attr('data-id');

    // alert(id)
    this.http.get<Aspar>(this.globals.urlMain + 'aspar', {
      params: {
        data: id,
      }
    }).subscribe(data => {
      this.aspar = data;
    });
    $('html, body').animate({
      scrollTop: $('.hayZinvorLast').offset().top
    });
  }

}
